

export enum ComponentTypeID {
    RiskAssessment = 1,
    ControlMeasure = 2,
    CriticalFailureMode = 3,
    Harm = 4,
    ControlMeasureCost = 5,
    ControlMeasureAssessment = 6,
    ControlMeasureAdequacy = 7,
    AssessmentTemplate = 8,
    SummaryOfKnowledge = 9,
    ReasonablyPracticable = 10,
    AdditionalControlMeasuer = 11,
    SummaryReasonablyPracticable = 12,
    SoceitalConcern = 13,


}

export interface IAssessmentSettings {
    id?: number,
    assessment_project_id: number,
    type: string,
    uuid: number,
    value_of_life: number,
    discount_rate: number,
    total_project_years: number,
    ancold_guideline_id: number,
    is_failure_mode_centric: boolean,
    is_active: boolean,
    safety_threshold_societal: number,
    safety_threshold_individual: number,
    consider_societal_concerns: boolean
}

export interface ITemplate {
    id?: number;
    name: string;
    uuid?: number;
    file_uuid: number;
    version: number;
    is_sub_template: boolean;
    is_active?: boolean;
    created_at?: string;
    sub_templates?: ITemplate[];
    


}

export enum AdequacyTypeID {
    Adequacy = 1,
    ControlMeasure = 2,
    ExistingControlMeasureHazard = 3,
    AdditionalControlMeasureHazard = 4,
    TotalSummary = 6,
    SocietyRisk = 7,
    SocietyConcern = 8

}

export interface IPortfolio {
    id?: number,
    name: string,
    is_active: boolean
}

export interface IDam {
    id?: number,
    name: string,
    valley?: string,
    longitude?: number,
    latitude?: number,
    project_id?: number

    is_active: boolean
}
export interface ICreator {
    username: string
}

export interface IError {
    error: string,
}

export interface IAssessmentProject {
    id?: number,
    name: string,
    is_active: boolean,
    dam?: IDam,
    creator?: ICreator
    _errors?: IError[]
}

export interface IAssessmentTemplateDetail {
    description: string,
    template: IAssessmentTemplate,
    adequacy: IAdequacy,
    uuid: number,
}

export interface IAdequacy {
    id?: number,
    level: number,
    name: string,
    type_id: AdequacyTypeID,
    assessment_type_id?: number,
}

export interface IAssessmentTemplate {
    uuid?: number,
    name: string,
    display_order: number,
    group: IAssessmentTemplateGroup,
    assessment_type_id?: number,
    assessment_type?: IAssessmentType
}

export interface IAssessmentType {
    id?: number,
    name: string
}

export interface IAssessmentTemplateGroup {
    uuid?: number,
    name: string,
}

export interface IAssessment {
    id?: number,
    justification: string,
    assessment_template_detail_id: number,
    assessment_template_detail?: IAssessmentTemplateDetail
    state_id?: number,
}

export interface IFailureMode {
    uuid: number,
    name: string,
    is_active?: boolean,
}

export interface IState {
    id?: number,
    uuid: number,
    name: string,
    parent_state_datetime?: string,
    parent_state_uuid?: number,
    assessment_project_id: number,
    is_active?: boolean,
    created_at?: string
}

export interface IProjectFailureMode {
    id?: number,
    failure_mode_id?: number
    failure_mode?: IFailureMode
}

export interface IRiskAssessment {
    id?: number,
    assessment_project_id?: number,
    uuid?: number,
    annual_failure_probability?: number,
    societal_risk?: number,
    project_failure_mode_id?: number,
    project_failure_mode?: IProjectFailureMode
    individual_risk?: number,
    failure_mode?: string,
    description?: string,
    document?: IDocument,
    document_id?: number,
    is_active?: boolean

}

export interface ICriticalHazards {
    project_failure_mode_id: number,
    max_annual_failure_probability: number,
    max_societal_risk: number,
    sum_societal_risk: number,
    max_individual_risk: number,
    contribution_to_societal_risk: number,
    contribution_to_individual_risk: number,
    critical: boolean,
    societal_confidence_id: number,
    individual_confidence_id: number,
}

export interface IControlMeasure {
    id?: number,
    uuid: number,
    description: string,
    comment?: string
    existing: boolean,
    control_type_id: number,
    document?: IDocument,
    document_id?: number,
    is_active?: boolean
    state_id?: number,
    order?: number
}

export interface IControlType {
    id?: number,
    name: string
}

export interface IControlMeasureFailureMode {
    id?: number,
    control_measure_id: number,
    project_failure_mode_id: number,
    priority: number,
    state_id?: number,
}

export interface IControlMeasureAssessment {
    id?: number,
    control_measure_id: number,
    project_failure_mode_id: number,
    adequacy_id?: number,
    justification?: string
    de_minimis?: boolean
    good_practice?: boolean
    practicable?: boolean
    effective?: boolean
    considered?: boolean
    overall_assessment_id?: number
    overall_justification?: string
}

export interface ISeverity {
    id?: number,
    name: string
}

export interface IConsequence {
    id?: number,
    name: string,
    level: number
}

export interface IHarm {
    id?: number,
    project_failure_mode_id?: number,
    severity_id?: number,
    potential_life_loss?: number,

    population_at_risk?: number,
    economics?: number,
    environmental?: number,
    special_consideration?: string,
    special_consideration_description?: string,

    consequence_id?: number,
    consequence?: IConsequence

}

export interface IControlAdequacy {
    id?: number,
    level: number,
    name: string,
}

export interface IConsequenceCategory {

    assessment_project_id?: number,
    category?: string,
    damage?: number,
    document_id?: number,
    document?: IDocument,
    driver_of_severity?: string,
    id?: number,
    is_active?: boolean,
    loss_rating?: string,
    name?: string,
    pll?: number,
    uuid?: number
}


export interface IControlMeasureCost {
    id?: number,
    control_measure_id: number,
    cost?: number,
    societal_risk_before?: number,
    societal_risk_after?: number,
    individual_risk_before?: number,
    individual_risk_after?: number,
    economic_risk_before?: number,
    economic_risk_after?: number,
    public_benefits_before?: number,
    public_benefits_after?: number,
    operating_cost_before?: number,
    operating_cost_after?: number,
    implementation_time?: number,
    cssl?: number,
    annualised_cost?: number,
    df?: number,
    cost_adequacy?: ICostAdequacy,
    cost_adequacy_id?: number,
    document?: IDocument,
    document_id?: number,
    created_at?: string,
    state_id?: number,
    value_of_life?: number,
    discount_rate?: number,
    total_project_years?: number,
    fd?: number,

}

export interface IUpload {
    id?: number,
    name: string,
    uuid: number,
    document_id?: number
}

export interface IDocument {
    id?: number,
    uuid?: number,
    document_type_id?: number,
    name?: string,
    reference?: string,
    comment?: string,
    author?: string,
    filename?: string,
    description?: string,
    date?: string
    assessment_project_id?: number,
    is_active?: boolean,
}

export interface IUser {
    username?: string
    password?: string
    token?: string
}

export interface IRole {
    name: string,
    id: number
    access_level: number
}

export interface IUserAdmin {
    id?: number,
    email?: string,
    roles?: IRole[],
    is_active: boolean
}



export interface IProjectUser {
    id?: number,
    user_id: number,
    project_id: number,
    access_level: number,
    user?: {    
        email: string,
    }
}

export interface IFailureModeAssessment {
    id?: number,
    assessment_project_id?: number,
    project_failure_mode_id: number,
    assessment?: string,
    consider?: boolean,
    uncertainty?: number
}

export interface ICostAdequacy {
    id?: number,
    level: number,
    name: string
}

export interface IFNCurve {
    id?: number,
    control_measure_id?: number,
    is_existing: boolean,
    upload_id?: number,
    document_id?: number,
    document?: IDocument,
    is_active?: boolean
}

export interface IFNData {
    id?: number,
    f: number,
    n: number,
    cn_curve_id: number
}
export interface IRealUser {
    email: string
}
export interface IComment {
    id?: number,
    uuid?: number,
    comment: string,
    comment_thread_id: number,
    assessment_project_id?: number,
    state_id?: number,
    created_at?: string,
    is_active?: boolean,
    user?: IRealUser
}


export interface ICommentThread {
    id?: number,
    uuid?: number,
    is_active: boolean,
    parent_uuid: number,
    type_id: number,
    assessment_project_id?: number,
    state_id?: number,
    comments?: IComment[]
}

export interface IFailureMode {
    id?: number,
    name: string,
    selected?: boolean,
    existing?: boolean
}

export interface IControlMeasureAdequacy {
    id?: number,
    project_failure_mode_id: number,
    additional_adequacy_id?: number,
    improvement_adequacy_id?: number,
    existing_adequacy_id?: number,
    comment?: string,
    additional_adequacy?: IAdequacy,
    improvement_adequacy?: IAdequacy,
    existing_adequacy?: IAdequacy
}

export interface IControlMeasureConcern {
    id?: number,
    project_failure_mode_id: number,
    concern_id?: number,
    risk_to_society_id?: number,
    risk_of_concern_id?: number,
    state_id?: number,
    comment?: string,
    concern?: IAdequacy,
    risk_to_society?: IAdequacy,
    risk_of_concern?: IAdequacy
}

export interface ISummaryKnowledge {
    id?: number,
    assessment_template_group_id: number,
    group?: IAssessmentTemplateGroup,
    required_studies?: string,
    gaps?: string,

}

export interface ISummaryTotalKnowledge {
    id?: number,
    description?: string,
    adequacy_id?: number,
    adequacy?: IAdequacy,

}

export interface IInvestigation {
    id?: number,
    uuid: number
    name?: string,
    assessment_project_id?: number,
    assessment_template_group_id?: number,
    cost?: number,
    timeframe?: number,
    document?: IDocument,
    document_id?: number,
    is_active: boolean,
    group?: IAssessmentTemplateGroup,
    state_id?: number,
}

export interface IDataGap {
    id?: number,
    uuid: number
    name?: string,
    assessment_template_id?: number,
    assessment_template_group_id?: number,
    is_active: boolean,
    group?: IAssessmentTemplateGroup,
    state_id?: number,
}

export interface IInvestigationAssessment {
    id?: number,
    investigation_uuid: number,
    link_type: number,
    assessment_uuid: number,
    is_active: boolean,
    state_id?: number,
}

export interface ISummary {
    number_of_dams?: number
}

export interface IStateOfKnowledge {
    assessment_project_id: number,
    assessment_template_detail: {
        adequacy: {
            level: number,
            name: string,
        },
        description: string,
        id: number,
        template: {
            group: {
                id: number,
                name: string
            },
            id: number,
            name: string
        }
    },
    assessment_template_detail_id: number,
    id: number,
    justification: string
}

export interface IDamsList {

    _errors: [
        {
            error: string
        }
    ],
    creator_id: number,
    dam: {
        id: number,
        is_active: boolean,
        latitude: number,
        longitude: number,
        name: string,
        project_id: string,
        valley: string
    },
    id: number,
    name: string,
    societal_risk_before: number

}

export interface IInfo {
    version: string
}

export interface ISummaryCriticalHazards {
    project_failure_mode_id: number,
    max_annual_failure_probability: number,
    max_societal_risk: number,
    sum_societal_risk: number,
    max_individual_risk: number,
    contribution_to_societal_risk: number,
    contribution_to_individual_risk: number,
    critical: boolean,
    societal_confidence_id: number,
    individual_confidence_id: number,
    assessment_project_id: number,
}


export type dataEntry = { name: string, value: Array<number> }


export interface IDataTest<T> {
    legend_labels?: Array<string>,
    description: Array<string>,
    data: Array<T>,
    colour: {
        background: Array<string>,
        font: Array<string>
    },
    title: string,
    height?: number,
    axis_label?: {y: string, x: string},
    subtitle?: string,
    radius?: string,
}

export interface ITag {
    id?: number,
    uuid: number,
    is_active: boolean,
    name: string
    description: string
}

export interface ITagEntry {
    id?: number,
    is_active: boolean,
    entry_uuid: number,
    tag_uuid: number,
    link_type: number,
}

export interface ITag {
    id?: number,
    uuid: number,
    is_active: boolean,
    name: string
    description: string
}

export interface ITagEntry {
    id?: number,
    is_active: boolean,
    entry_uuid: number,
    tag_uuid: number,
    link_type: number,
}


export interface ISummaryControlMeasureAdequacy {

    additional_adequacy: {
        id: number,
        leve: number,
        name: string,
        type_id: number
    },
    additional_adequacy_id: number,
    assessment_project_id: number,
    comment: string,
    existing_adequacy: {
        id: number,
        level: number,
        name: string,
        type_id: number
    },
    existing_adequacy_id: number,
    id: number,
    improvement_adequacy: {
        id: number,
        level: number,
        name: string,
        type_id: number
    },
    improvement_adequacy_id: number,
    project_failure_mode_id: number

}


export interface ISummaryControlMeasureAssessment {

    adequacy_id: number,
    assessment_project_id: number,
    considered: boolean,
    control_measure_id: number,
    de_minimis: boolean,
    effective: boolean,
    good_practice: boolean,
    id: number,
    justification: string,
    overall_assessment_id: number,
    overall_justification: string,
    practicable: boolean,
    project_failure_mode_id: number

}

export interface ISummarySOK {

    adequacy: {
        level: number,
        name: string
    },
    adequacy_id: number,
    assessment_project_id: number,
    description: string,
    id: number


}

export interface ILikelihood {

    assessment_project_id: number,
    max_annual_failure_probability: number
}


export interface IHarmSummary {

    assessment_project_id: number,
    category: string,
    damage: number,
    document: {
        assessment_project_id: number,
        author: string,
        description: string,
        document_type_id: number,
        filename: string,
        id: number,
        name: string,
        reference: string
    },
    document_id: number,
    driver_of_severity: string,
    id: number,
    is_active: boolean,
    loss_rating: string,
    name: string,
    pll: number,
    uuid: number
}

export interface ICostSummary {

    annualised_cost: number,
    assessment_project_id: number,
    control_measure_id: number,
    cost: number,
    cost_adequacy: {
        id: number,
        level: number,
        name: string,
        threshold: number
    },
    cost_adequacy_id: number,
    cssl: number,
    df: number,
    document: {
        assessment_project_id: number,
        author: string,
        description: string,
        document_type_id: number,
        filename: string,
        id: number,
        name: string,
        reference: string
    },
    document_id: number,

    economic_risk_after: number,
    economic_risk_before: number,
    id: number,
    implementation_time: number,
    individual_risk_after: number,
    individual_risk_before: number,
    operating_cost_after: number,
    operating_cost_before: number,
    public_benefits_after: number,
    public_benefits_before: number,
    societal_risk_after: number,
    societal_risk_before: number

}

export interface ISocietalRisk {
    assessment_project_id: number,
    societal_risk_before: number

}

export interface IPathway {
    assessment_project_id: number,
    control_measure_uuid: number,
    implemented_state_uuid?: number,
    order : number,
    state_uuid: number
}

export interface IImplementation {
    id? : number,
    assessment_project_id : number,
    state_uuid : number,
    name : string,
    is_current : boolean,
    is_active : boolean,
    pathways?: IPathway[]

}

export interface ImplemenationPathway {
    implemenation_id : number,
    assessment_project_id : number,
    state_uuid : number,
    order : number,
    control_measure_uuid : number
}